// @flow
import remote from './remote';

export function getGroups(query: Object): Promise<Object> {
  return remote.get('groups', query);
}

export function getGroup(id: number, query: Object = {}): Promise<Object> {
  return remote.get(`groups/${id}`, query);
}

export function createGroup(data: Object): Promise<Object> {
  return remote.post('groups', data);
}

export function updateGroup(id: number, data: Object): Promise<Object> {
  return remote.put(`groups/${id}`, data);
}

export function deleteGroup(id: number): Promise<Object> {
  return remote.delete(`groups/${id}`);
}

